// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCompanyFeedbacksRequestModel from '../../model/get-company-feedbacks-request-model';
import GetCompanyFeedbacksRequestDTO from '../dto/get-company-feedbacks-request-dto';
import dtoSchema from '../schemas/get-company-feedbacks-request-schema';

export default abstract class GetCompanyFeedbacksRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCompanyFeedbacksRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.eventIdentifier = data.eventIdentifier;
      this.selectedOrganisationId = data.selectedOrganisationId;
      this.selectedEventId = data.selectedEventId;
      this.id = data.id;
      this.key = data.key;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {uuid}
  */
  eventIdentifier?: string;
  /**
  * @type {int64}
  */
  selectedOrganisationId?: number;
  /**
  * @type {int64}
  */
  selectedEventId?: number;
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  key?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetCompanyFeedbacksRequestDTO>): GetCompanyFeedbacksRequestModel;
  static toModel(dto: DeepPartial<GetCompanyFeedbacksRequestDTO> | undefined | null): GetCompanyFeedbacksRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCompanyFeedbacksRequestDTO> | undefined | null): GetCompanyFeedbacksRequestModel | undefined {
    return dto ? new GetCompanyFeedbacksRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCompanyFeedbacksRequestModel> | GetCompanyFeedbacksRequestModel): GetCompanyFeedbacksRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      eventIdentifier: unwrapped.eventIdentifier,
      selectedOrganisationId: unwrapped.selectedOrganisationId,
      selectedEventId: unwrapped.selectedEventId,
      id: unwrapped.id,
      key: unwrapped.key,
      searchCriteria: unwrapped.searchCriteria,
    } as GetCompanyFeedbacksRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCompanyFeedbacksRequestModel, can not map to GetCompanyFeedbacksRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
